import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_FETCH_ENABLED_SITES_BEGIN,
  MANAGE_SUBS_FETCH_ENABLED_SITES_SUCCESS,
  MANAGE_SUBS_FETCH_ENABLED_SITES_FAILURE,
  MANAGE_SUBS_FETCH_ENABLED_SITES_DISMISS_ERROR,
} from './constants';

export function fetchEnabledSites(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_ENABLED_SITES_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.get(`http://localhost:9002/sia/siaplus/getEnabledSites`, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data.siteDetails;
          dispatch({
            type: MANAGE_SUBS_FETCH_ENABLED_SITES_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: MANAGE_SUBS_FETCH_ENABLED_SITES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchEnabledSitesError() {
  return {
    type: MANAGE_SUBS_FETCH_ENABLED_SITES_DISMISS_ERROR,
  };
}

export function useFetchEnabledSites() {
  const dispatch = useDispatch();

  const {enabledSites, fetchEnabledSitesPending, fetchEnabledSitesError } = useSelector(
    state => ({
      enabledSites: state.manageSubs.enabledSites,
      fetchEnabledSitesPending: state.manageSubs.fetchEnabledSitesPending,
      fetchEnabledSitesError: state.manageSubs.fetchEnabledSitesError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchEnabledSites(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchEnabledSitesError());
  }, [dispatch]);

  return {
    enabledSites,
    fetchEnabledSites: boundAction,
    fetchEnabledSitesPending,
    fetchEnabledSitesError,
    dismissFetchEnabledSitesError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_ENABLED_SITES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchEnabledSitesPending: true,
        fetchEnabledSitesError: null,
      };

    case MANAGE_SUBS_FETCH_ENABLED_SITES_SUCCESS:
      // The request is success
      return {
        ...state,
        enabledSites:action.data,
        fetchEnabledSitesPending: false,
        fetchEnabledSitesError: null,
      };

    case MANAGE_SUBS_FETCH_ENABLED_SITES_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchEnabledSitesPending: false,
        fetchEnabledSitesError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_ENABLED_SITES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchEnabledSitesError: null,
      };

    default:
      return state;
  }
}
